<template>
  <el-drawer :visible.sync="drawer" direction="rtl" size="50%" :modal-append-to-body="false" :before-close="handleClose" :title="title">
    <div class="send-email-drawer-content">
      <el-form v-if="drawer" ref="form" class="send-email-form" label-position="top" :model="form" :disabled="disabled" :rules="rules" label-width="160px" style="padding:16px;">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('SendEmail.table.EmailTitle')" prop="mailTitle">
              <BjInput v-model="form.mailTitle" :maxlength="MAX_LENGTH.BILLMAX" :placeholder="$t('inputText')" clearable />
            </el-form-item>
            <el-form-item :label="$t('SendEmail.table.EmailContent')" prop="content">
              <BjInput v-model="form.content" type="textarea" :rows="16" show-word-limit :maxlength="2000" :placeholder="$t('inputText')" clearable />
            </el-form-item>
            <el-form-item :label="$t('SendEmail.table.EmailType')" prop="emailType">
              <BjSelectLov v-model="form.emailType" :option-list="emailTypeList" :clearable="false" @change="changeCustomerType" />
            </el-form-item>
            <el-form-item :label="$t('SendEmail.table.Multiples')">
              <UploadFile ref="UploadFileRef" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange">
                <template slot="default">
                  <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                </template>
              </UploadFile>
            </el-form-item>
            <el-form-item :label="$t('SendEmail.table.RequireConfirmation')" prop="requireConfirmation">
              <el-switch v-model="form.requireConfirmation" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="send-email-footer">
        <el-button type="danger" @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" :disabled="disabled" @click="handleConfirm">{{ $t('okText') }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import UploadFile from '@/views/center-business/third/csg/order/components/UploadFile';
import { userApi } from '@/api';
const getDefaultForm = () => {
  return {
    mailTitle: null,
    content: null,
    annex: null,
    emailType: null,
    requireConfirmation: 0
  };
};
export default {
  components: { UploadFile },
  data() {
    return {
      title: '',
      form: getDefaultForm(),
      emailTypeList: [
        {label: this.$t('SendEmail.table.Generalemail'), value: 1},
        {label: this.$t('SendEmail.table.BillingEmail'), value: 2},
        {label: this.$t('SendEmail.table.CustomerServiceEmail'), value: 3},
      ],
      fileList: [],
      rules: {
        mailTitle: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        content: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        emailType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        annex: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
      disabled: false,
      drawer: false,
    };
  },
  methods: {
    show(row) {
      this.disabled = !!row;
      this.title = this.$t(row ? 'viewText' : 'addText');
      this.form = { ...getDefaultForm(), ...(row || {}) };
      this.form.requireConfirmation = Number(this.form.requireConfirmation) === 1 ? 1 : 0;
      let annex = row && row.annex;
      if (typeof annex === 'string') {
        try {
          annex = annex.trim() ? JSON.parse(annex) : [];
        } catch (error) {
          annex = [];
        }
      }
      this.fileList = Array.isArray(annex)
        ? annex.filter(item => item && typeof item === 'object').map(item => ({ ...item }))
        : [];
      this.drawer = true;
      this.$nextTick(() => {
        if (this.$refs.UploadFileRef) this.$refs.UploadFileRef.fileList = this.fileList;
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    handleClose(){
      this.drawer = false;
      this.form = getDefaultForm();
      this.fileList = []
    },
    fileListChange(file) {
      const totalSize = file.reduce((total, item) => total + item.size, 0)
      if(totalSize > 1024 * 1024 * 30) return this.$message.warning(this.$t('ExcelConfig.maximum2'));

      this.fileList = file.map(item => { return { name : item.name, url: item.url}});
      this.form.annex = JSON.stringify(this.fileList)
    },
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          userApi.massassAdd(this.form).then(()=>{
            this.handleClose()
            this.$message.success(this.$t('toast.operationSuccessText'))
            this.$emit('reFresh')
          })
        }
      })
    },
  },
};
</script>

<style scoped>
.send-email-drawer-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.send-email-form {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.send-email-footer {
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  padding: 16px;
}
.send-email-footer .el-button {
  width: 120px;
}
</style>
